import moment from 'moment-timezone'

enum WithinMonthOffset {
  Forward = 1,
  Backward = -1,
  Current = 0,
}

const nextDay = (date: Date) => new Date(date.setDate(date.getDate() + 1))
const prevDay = (date: Date) => new Date(date.setDate(date.getDate() - 1))

export const getMaxDate = (timezone: string) => {
  const targetTimezoneDay = moment.tz(timezone).date()
  const currentTimezoneDay = new Date().getDate()

  const offset = targetTimezoneDay - currentTimezoneDay

  switch (offset) {
    case WithinMonthOffset.Current:
      return new Date()
    case WithinMonthOffset.Forward:
      return nextDay(new Date())
    case WithinMonthOffset.Backward:
      return prevDay(new Date())
    default:
      // if offset is not 1, 0 or -1 so it's another month
      return offset < 0 ? nextDay(new Date()) : prevDay(new Date())
  }
}
